/* AZP-7082 — Blog List keyword search (sections/main-blog.liquid).
 *
 * Liquid cannot read ?q=, so the search runs here: every article of the current
 * category is loaded from the blog.search-index template, the articles whose
 * title or description contain every word of the keyword are kept (case
 * insensitive, newest first like the blog) and paged in the browser. The keyword
 * stays in the URL and on the category tab links, so choosing a category filters
 * the results further, and reload / back keep the search.
 */
(function () {
  'use strict';

  // Gap kept between the results and the top of the viewport after a page change.
  var GAP = 16;

  function normalize(text) {
    return text
      .toLowerCase()
      .replace(/[‘’]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Pages shown around the current one, e.g. 1 2 3 … 23 or 1 … 4 5 6 … 23; null is an ellipsis.
  function pageItems(current, total) {
    var pages = [1, total, current - 1, current, current + 1];
    if (current === 1) pages.push(3);
    if (current === total) pages.push(total - 2);
    pages = pages
      .filter(function (page, index) {
        return page >= 1 && page <= total && pages.indexOf(page) === index;
      })
      .sort(function (a, b) {
        return a - b;
      });

    var items = [];
    pages.forEach(function (page, index) {
      var gap = page - (index ? pages[index - 1] : 0);
      if (gap === 2) items.push(page - 1);
      if (gap > 2) items.push(null);
      items.push(page);
    });
    return items;
  }

  // Same rules as the FAQ page (section-faq.js): scrolling up reveals the sticky header.
  function scrollToTop(element) {
    var targetTop = element.getBoundingClientRect().top + window.pageYOffset;
    var header = document.querySelector('.section-header');
    var stickyHeader = document.querySelector('sticky-header');
    var stickyEnabled = !!stickyHeader && stickyHeader.getAttribute('disabled') !== 'true';
    var headerSpace = targetTop < window.pageYOffset && header && stickyEnabled ? header.offsetHeight : 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({ top: targetTop - headerSpace - GAP, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function initBlogList(root) {
    if (root.dataset.blogListReady) return;
    root.dataset.blogListReady = 'true';

    var form = root.querySelector('[data-blog-search]');
    var input = root.querySelector('[data-blog-search-input]');
    var clearButton = root.querySelector('[data-blog-search-clear]');
    var results = root.querySelector('[data-blog-results]');
    var grid = root.querySelector('[data-blog-results-grid]');
    var empty = root.querySelector('[data-blog-empty]');
    var pagination = root.querySelector('[data-blog-results-pagination]');
    var queryLabel = root.querySelector('[data-blog-query]');
    var tabList = root.querySelector('[data-blog-tabs]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-blog-tab]'));
    var pageSize = Number(root.dataset.pageSize) || 12;
    var maxLength = input.maxLength > 0 ? input.maxLength : 50;

    var entriesRequest = null;
    var matches = [];
    var activeQuery = '';

    // Leaving the search (× button, or clearing the keyword of an active search) goes back to
    // the blog page, without keyword or category.
    function goToBlog() {
      window.location.assign(root.dataset.blogUrl);
    }

    function syncClearButton() {
      clearButton.hidden = !input.value;
    }

    function queryFromUrl() {
      return (new URLSearchParams(window.location.search).get('q') || '').trim().slice(0, maxLength);
    }

    function fetchIndexPage(baseUrl, page) {
      var url = baseUrl + '?view=search-index&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Blog search index: ' + response.status + ' ' + url);
          return response.text();
        })
        .then(function (html) {
          return new DOMParser().parseFromString(html, 'text/html');
        });
    }

    var indexRequests = {};

    // Every page of the search index at baseUrl (the blog or a tag URL), loaded once per page
    // view; a failed request is retried the next time.
    function loadIndex(baseUrl) {
      if (!indexRequests[baseUrl]) {
        indexRequests[baseUrl] = fetchIndexPage(baseUrl, 1)
          .then(function (firstPage) {
            var index = firstPage.querySelector('[data-blog-index]');
            var pageCount = Number(index && index.dataset.pages) || 1;
            var requests = [firstPage];
            for (var page = 2; page <= pageCount; page++) requests.push(fetchIndexPage(baseUrl, page));
            return Promise.all(requests);
          })
          .catch(function (error) {
            delete indexRequests[baseUrl];
            throw error;
          });
      }
      return indexRequests[baseUrl];
    }

    // Search entries of the current category. Their cards are moved into the results grid, so
    // they are collected once.
    function loadEntries() {
      if (!entriesRequest) {
        entriesRequest = loadIndex(root.dataset.indexUrl)
          .then(function (pages) {
            var entries = [];
            pages.forEach(function (doc) {
              doc.querySelectorAll('[data-blog-entry]').forEach(function (element) {
                entries.push({ element: element, text: normalize(element.dataset.search || '') });
              });
            });
            return entries;
          })
          .catch(function (error) {
            entriesRequest = null;
            throw error;
          });
      }
      return entriesRequest;
    }

    function updateTabs(query) {
      tabs.forEach(function (tab) {
        var url = new URL(tab.href, window.location.origin);
        if (query) {
          url.searchParams.set('q', query);
        } else {
          url.searchParams.delete('q');
        }
        tab.href = url.pathname + url.search;
      });
    }

    function createArrow(direction, page) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bs-blog-pagination__arrow bs-blog-pagination__arrow--' + direction;
      button.dataset.page = page;
      button.setAttribute('aria-label', direction === 'prev' ? root.dataset.labelPrevious : root.dataset.labelNext);

      var icon = document.createElement('img');
      icon.src = root.dataset.chevron;
      icon.alt = '';
      icon.width = 20;
      icon.height = 20;
      button.appendChild(icon);
      return button;
    }

    // Same markup as the Liquid pagination, with buttons instead of links.
    function renderPagination(current, total) {
      pagination.textContent = '';
      pagination.hidden = total < 2;
      if (total < 2) return;

      var list = document.createElement('ul');
      list.className = 'bs-blog-pagination__pages';
      list.setAttribute('role', 'list');

      pageItems(current, total).forEach(function (page) {
        var item = document.createElement('li');
        if (page === null || Math.abs(page - current) > 1) item.className = 'is-edge';
        var isLink = page !== null && page !== current;
        var control = document.createElement(isLink ? 'button' : 'span');
        control.className = 'bs-blog-pagination__page';
        control.textContent = page === null ? '…' : page;

        if (isLink) {
          control.type = 'button';
          control.dataset.page = page;
          control.setAttribute('aria-label', root.dataset.labelPage.replace('[number]', page));
        } else if (page === current) {
          control.classList.add('is-active');
          control.setAttribute('aria-current', 'page');
        }

        item.appendChild(control);
        list.appendChild(item);
      });

      if (current > 1) pagination.appendChild(createArrow('prev', current - 1));
      pagination.appendChild(list);
      if (current < total) pagination.appendChild(createArrow('next', current + 1));
    }

    function renderPage(page) {
      var start = (page - 1) * pageSize;
      grid.textContent = '';
      matches.slice(start, start + pageSize).forEach(function (match) {
        grid.appendChild(match.element);
      });
      renderPagination(page, Math.ceil(matches.length / pageSize));
    }

    function showDefault() {
      root.classList.remove('is-searching');
      results.hidden = true;
      results.removeAttribute('aria-busy');
      grid.textContent = '';
      matches = [];
    }

    function search(query) {
      activeQuery = query;
      input.value = query;
      syncClearButton();
      updateTabs(query);

      if (!query) {
        showDefault();
        return;
      }

      root.classList.add('is-searching');
      results.hidden = false;
      results.setAttribute('aria-busy', 'true');
      queryLabel.textContent = query;
      grid.textContent = '';
      empty.hidden = true;
      pagination.hidden = true;

      loadEntries().then(
        function (entries) {
          if (query !== activeQuery) return;

          var words = normalize(query).split(' ');
          matches = entries.filter(function (entry) {
            return words.every(function (word) {
              return entry.text.indexOf(word) !== -1;
            });
          });

          results.removeAttribute('aria-busy');
          empty.hidden = matches.length > 0;
          renderPage(1);
        },
        function (error) {
          console.error(error);
          if (query === activeQuery) showDefault();
        }
      );
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var query = input.value.trim().slice(0, maxLength);
      if (!query) {
        if (activeQuery) goToBlog();
        return;
      }

      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.set('q', query);
      if (url.href !== window.location.href) window.history.pushState({}, '', url);

      search(query);
    });

    clearButton.addEventListener('click', goToBlog);

    // Typing shows the × button. Deleting a half-typed keyword that was never searched stays
    // on the page; clearing an active search leaves it.
    input.addEventListener('input', function () {
      syncClearButton();
      if (!input.value.trim() && activeQuery) goToBlog();
    });

    // Start loading the articles while the keyword is being typed.
    input.addEventListener(
      'focus',
      function () {
        loadEntries().catch(function () {});
      },
      { once: true }
    );

    pagination.addEventListener('click', function (event) {
      var control = event.target.closest('[data-page]');
      if (!control) return;
      renderPage(Number(control.dataset.page));
      scrollToTop(results);
    });

    window.addEventListener('popstate', function () {
      search(queryFromUrl());
    });

    // Mobile: the tabs scroll sideways, so bring the current category into view.
    function centerActiveTab() {
      var activeTab = tabList && tabList.querySelector('.is-active');
      if (activeTab && tabList.scrollWidth > tabList.clientWidth) {
        tabList.scrollLeft = activeTab.offsetLeft - (tabList.clientWidth - activeTab.offsetWidth) / 2;
      }
    }

    // blog.all_tags sometimes renders empty; the list then holds only the tags Liquid could still
    // read (data-blog-tabs-partial), so rebuild it from the tags of every article.
    function completeTabs() {
      if (!tabList || !tabList.hasAttribute('data-blog-tabs-partial')) return;

      loadIndex(root.dataset.blogUrl)
        .then(function (pages) {
          var names = {};
          pages.forEach(function (doc) {
            doc.querySelectorAll('[data-blog-entry]').forEach(function (entry) {
              (entry.dataset.tags || '').split('||').forEach(function (pair) {
                var parts = pair.split('::');
                if (parts[1]) names[parts[1]] = parts[0];
              });
            });
          });
          var handles = Object.keys(names).sort(function (a, b) {
            return names[a].localeCompare(names[b], undefined, { sensitivity: 'base', numeric: true });
          });
          if (!handles.length) {
            // The blog has no tags at all: no category bar, as when Liquid finds none.
            if (tabList.children.length <= 1) tabList.closest('.bs-blog-tabs').remove();
            return;
          }

          // Keep "All Blog", replace the category tabs.
          var allItem = tabList.firstElementChild;
          tabList.textContent = '';
          tabList.appendChild(allItem);
          handles.forEach(function (handle) {
            var isActive = handle === root.dataset.currentTag;
            var link = document.createElement('a');
            link.className = 'bs-blog-tabs__tab' + (isActive ? ' is-active' : '');
            link.href = root.dataset.blogUrl + '/tagged/' + handle;
            link.textContent = names[handle];
            link.setAttribute('data-blog-tab', '');
            if (isActive) link.setAttribute('aria-current', 'page');

            var item = document.createElement('li');
            item.appendChild(link);
            tabList.appendChild(item);
          });

          tabList.removeAttribute('data-blog-tabs-partial');
          tabs = Array.prototype.slice.call(tabList.querySelectorAll('[data-blog-tab]'));
          updateTabs(activeQuery);
          centerActiveTab();
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    centerActiveTab();
    completeTabs();

    var initialQuery = queryFromUrl();
    if (initialQuery) {
      search(initialQuery);
    } else {
      root.classList.remove('is-searching');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-blog-list]').forEach(initBlogList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
